import { createStore, applyMiddleware, StoreEnhancer } from 'redux';
import thunk from 'redux-thunk';

import { rgpd } from '../middlewares/rgpd';
import rootReducer from '../reducers';

const IS_DEV = process.env.RAZZLE_ENV !== 'prod';

const withDevTools = (storeEnhancer: StoreEnhancer) => {
  /* istanbul ignore next */
  if (IS_DEV) {
    const composeWithDevTools =
      require('redux-devtools-extension').composeWithDevTools;
    return composeWithDevTools(storeEnhancer);
  }

  return storeEnhancer;
};

export const configureStore = (preloadedState = {}) => {
  const store = createStore(
    rootReducer,
    preloadedState,
    withDevTools(applyMiddleware(thunk, rgpd))
  );

  if (IS_DEV && module.hot) {
    module.hot.accept('../reducers', () => {
      const nextRootReducer = require('../reducers').default;
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
};

export type GlpStore = ReturnType<typeof configureStore>;
